// extracted by mini-css-extract-plugin
module.exports = {"layout":"cd01fbf7b5--layout--TjvSZ","spinner":"cd01fbf7b5--spinner--uIpxO","container":"cd01fbf7b5--container--O_TQ1","error":"cd01fbf7b5--error--bfnyQ"};